
/**
 * 강의 요약 정보의 언어별 번역 엔트리
 */
export type CourseDetailSummaryMetadataTranslationsItem = {
  /**
   * 해당 언어의 강의 설명 번역
   * @nullable
   */
  description?: string | null;
  /** 언어 코드 (예: ko, en) */
  language: string;
  /**
   * 해당 언어의 강의 제목 번역
   * @nullable
   */
  title?: string | null;
};
